<template>
  <div v-if="open" class="fixed z-10 inset-0 overflow-y-auto">
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span
      >
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="w-full">
            <div class="mt-3 text-center sm:mt-0 sm:my-4 sm:text-left">
              <template v-if="step === 1">
                <h3 class="text-lg leading-6 font-medium text-gray-900">What type of request do you want to add?</h3>
                <div class="mt-8 mb-6">
                  <label v-if="importEnable" class="inline-flex items-center cursor-pointer">
                    <input class="form-radio" type="radio" v-model="ruleTypeSelected" value="import">
                    <span class="ml-2">Import</span>
                  </label>
                  <label v-if="requestEnable" class="inline-flex items-center ml-6 cursor-pointer">
                    <input class="form-radio" type="radio" v-model="ruleTypeSelected" value="action">
                    <span class="ml-2">Actions</span>
                  </label>
                </div>
              </template>
              <template v-if="step === 2 && ruleTypeSelected === 'import'">
                <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4">Provide SSO ID of user you want to add</h3>
                <p>You can provide a list of SSO IDs separated by " " or ","</p>
                <div class="my-8">
                  <input v-model="users"
                         placeholder="Ex: CSD13432_2343"
                         :typeahead="true"
                         @tag-added="parseKeywords"
                         class="p-3 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline w-full h-full">

                         <!--tags
                    :add-tags-on-space="true"
                    :add-tags-on-comma="true"
                    placeholder="Ex: CSD13432_2343"
                    class="w-full h-full"
                    v-model="users"
                    @tag-added="parseKeywords"
                    :typeahead="true"
                  /-->
                </div>
                <template v-if="this.site.sitekey.includes('cdiscount')">
                  <el-checkbox v-model="byAdvertisorId" v-bind:value="false" @change="emitByAdvertisorId">Use advertisor ID instead of SSO ID</el-checkbox>
                </template>
              </template>
              <template v-if="step === 2 && ruleTypeSelected === 'action'">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Provide the rules</h3>
                <div class="my-8 px-2 pb-2" v-if="request.actions">

                  <div class="flex">
                    <input list="action" v-model="request.actions[0]" class="p-3 mr-2 w-6/12 cursor-pointer placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline" style="margin-bottom: 0;"/>
                    <datalist id="action">
                      <option v-for="event in events" :key="event.id" :value="event.alias">{{ event.alias }}</option>
                    </datalist>
                    <select
                      v-model="request.comparator"
                      class="p-3 mr-2 w-3/12 cursor-pointer placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline">
                      <option value="$eq">=</option>
                      <option value="$gt">&gt;</option>
                      <option value="$lt">&lt;</option>
                    </select>

                    <input
                      v-model="request.tresholdvalue" min="0" type="number"
                      class="p-3 w-3/12 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline">
                  </div>

                  <div class="mt-4 flex items-center justify-between">
                    <span class="mr-2">Mode :</span>
                    <select id="aggregator"
                            v-model="request.aggregator"
                            class="p-3 mr-2 w-6/12 cursor-pointer placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline" style="flex:1;margin-bottom: 0;">
                      <option value="SUM">Sum</option>
                      <option value="DAILYAVERAGE">Daily average</option>
                      <option value="WEEKLYAVERAGE">Weekly average</option>
                      <option value="MONTHLYAVERAGE">Monthly average</option>
                    </select>
                  </div>
                </div>
              </template>
              <template v-if="step === 3 && ruleTypeSelected === 'action'">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Choose the type of the period to this request action</h3>
                <div class="mt-8 mb-6">
                  <label class="inline-flex items-center cursor-pointer">
                    <input class="form-radio" type="radio" v-model="periodTypeSelected" value="static">
                    <span class="ml-2">Static</span>
                  </label>
                  <label class="inline-flex items-center ml-6 cursor-pointer">
                    <input class="form-radio" type="radio" v-model="periodTypeSelected" value="dynamic">
                    <span class="ml-2">Dynamic</span>
                  </label>
                </div>
              </template>
              <template v-if="step === 4 && ruleTypeSelected === 'action' && periodTypeSelected === 'static'">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Please, provide the dates</h3>
                <div class="mt-8 mb-6">
                  <el-date-picker
                    v-model="request.datestart"
                    @change="setDate($event, true, request)"
                    placeholder="Date de début"
                    :picker-options="dateStartTimestamp"
                    :unlink-panels="true"
                  />
                  <div class="mb-1">&nbsp;</div>
                  <el-date-picker
                    v-model="request.dateend"
                    @change="setDate($event, false, request)"
                    placeholder="Date de fin"
                    :picker-options="dateEndTimestamp"
                    :unlink-panels="true"
                  />
                </div>
              </template>
              <template v-if="step === 4 && ruleTypeSelected === 'action' && periodTypeSelected === 'dynamic'">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Please, provide the rolling days</h3>
                <div class="mt-8 mb-6">
                  <select v-model="request.rollingdays" class="w-full p-3 flex-1 cursor-pointer placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline">
                    <option value="7" selected>7 last days</option>
                    <option value="30">30 last days</option>
                    <option value="90">90 last days</option>
                  </select>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button
            @click="nextStep()"
            type="button"
            class="w-full bg-primary inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Next
          </button>
          <button
            v-if="step > 1"
            @click="previousStep()"
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Previous
          </button>
          <button
            @click="$emit('close')"
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import moment from 'moment-timezone'

export default {
  name: 'BubblesUiModalCreationRules',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    importEnable: {
      type: Boolean,
      default: true
    },
    requestEnable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    var data = {
      step: 1,
      ruleTypeSelected: null,
      users: null,
      periodTypeSelected: null,
      request: {
        comparator: '$eq',
        tresholdvalue: 0,
        datestart: null,
        dateend: null,
        aggregator: 'SUM'
      },
      byAdvertisorId: false
    }

    if (this.importEnable === false) {
      data.ruleTypeSelected = 'action'
    }

    return data
  },
  computed: {
    ...mapGetters('events', {
      events: 'events'
    }),
    ...mapGetters('account', {
      site: 'currentSite'
    }),
    isDisabledNextButton () {
      if (this.step === 2 && this.ruleTypeSelected === 'import') {
        return false
      }
      return true
    },
    dateStartTimestamp () {
      return {
        disabledDate: (time) => {
          if (this.request.dateend) {
            return time.getTime() > (new Date(this.request.dateend)).getTime()
          }
          return false
        }
      }
    },
    dateEndTimestamp () {
      return {
        disabledDate: (time) => {
          if (this.request.datestart) {
            return time.getTime() < (new Date(this.request.datestart)).getTime()
          }
          return false
        }
      }
    }
  },
  methods: {
    ...mapActions('events', ['loadEvents']),
    async nextStep () {
      if (this.step === 1 && this.ruleTypeSelected) {
        await this.processStepOne()
        return this.step++
      }

      if (this.step === 2 && this.ruleTypeSelected) {
        this.processStepTwo()
        if (this.ruleTypeSelected === 'action') {
          for (let i = 0; i < this.events.length; i++) {
            if (this.events[i].alias.indexOf(this.request.actions[0]) !== -1) {
              return this.step++
            }
          }
        } else {
          return this.step++
        }
      }

      if (this.step === 3 && this.ruleTypeSelected && this.periodTypeSelected) {
        this.processStepThree()
        return this.step++
      }

      if (this.step === 4 && this.ruleTypeSelected && this.periodTypeSelected) {
        this.processStepFourth()
        if (this.periodTypeSelected === 'static') {
          if (this.request.datestart) {
            return this.step++
          }
        } else {
          return this.step++
        }
      }
    },
    async processStepOne () {
      if (this.ruleTypeSelected === 'action') {
        await this.loadEvents()
        this.request.actions = [this.events.alias]
      }
    },

    processStepTwo () {
      if (this.ruleTypeSelected === 'import') {
        this.$emit('users', this.users.split(/[\s,]+/))
        this.$emit('close')
      }
    },
    processStepThree () {
      if (this.ruleTypeSelected === 'action' && this.periodTypeSelected === 'none') {
        this.$emit('request', this.request)
        this.$emit('close')
      }
      if (this.ruleTypeSelected === 'action' && this.periodTypeSelected === 'dynamic') {
        this.request.rollingdays = 7
      }
    },
    processStepFourth () {
      if (this.ruleTypeSelected === 'action' && this.periodTypeSelected && this.periodTypeSelected !== 'none') {
        if (this.periodTypeSelected === 'static' && this.request.datestart && this.request.dateend) {
          if (this.request.datestart === this.request.dateend && this.request.datestart !== null) {
            // 86400000 ms == 1 day
            this.request.dateend = moment.utc((new Date(this.request.datestart)).getTime() + 86400000 - 1).format()
          }
          this.$emit('request', this.request)
          this.$emit('close')
        }
        if (this.periodTypeSelected === 'dynamic' && this.request.rollingdays) {
          this.$emit('request', this.request)
          this.$emit('close')
        }
      }
    },
    previousStep () {
      this.step--
    },
    setDate (date, start, request) {
      request.rollingdays = null
      if (start && date !== null) {
        request.datestart = moment.utc(date).format()
      }

      if (!start && date !== null) {
        request.dateend = moment.utc(date).format()
      }
    },
    parseKeywords (keyword) {
      let val = keyword.value
      if (val.indexOf(',') !== -1 || val.indexOf(';') !== -1) {
        this.users.pop()
        val.split(/[,;]/).forEach(val => {
          let found = this.users.some(el => el.value === val)
          if (!found && val.trim().length > 0) {
            this.users.push({key: val, value: val})
          }
        })
      }
    },
    emitByAdvertisorId () {
      this.$emit('useAdvertisorId', this.byAdvertisorId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bubbles/ui/modal/creation-rules.vue